"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const renderformbyfile_form_1 = __importDefault(require("./renderformbyfile.form"));
const Field_1 = __importDefault(require("../../_classes/field/Field"));
const AriFormUtils = __importStar(require("../../../utils/utils"));
const AriForm_1 = require("../../../AriForm");
// import * as AriFormUtils from '../../../utils/utils';
/**
 * Here we will derive from the base component which all Ari.Form form components derive from.
 * @param component
 * @param options
 * @param data
 * @class
 */
class RenderFormbyFileComponent extends Field_1.default {
    constructor(component, options, data) {
        super(component, options, data);
        this.StatusData = {};
    }
    static schema(...extend) {
        return Field_1.default.schema({
            type: 'renderformbyfile',
            label: 'Render Form by File',
            displayInfo: false,
            textContent: '',
            align: 'justify-content-start',
            action: 'event',
            templatesTextinfo: RenderFormbyFileComponent.defaultRowTemplate,
        }, ...extend);
    }
    get defaultSchema() {
        return RenderFormbyFileComponent.schema();
    }
    get emptyValue() {
        return this.getValue();
    }
    render() {
        var view = `<div ref="${this.component.key}-renderformbyfile-component" class="">
      <input ref="${this.component.key}-renderformbyfile-input-component" type="file" accept=".pdf" class="form-control" />
    </div>`;
        return super.render(view);
    }
    setValue(value, flags = {}) {
        const changed = super.setValue(value, flags);
        if (changed) {
            this.StatusData = value || {};
            this.redraw();
        }
        return changed;
    }
    getValue() {
        return this.value;
    }
    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        var refs = {};
        refs[`${this.component.key}-renderformbyfile-component`] = 'single';
        refs[`${this.component.key}-renderformbyfile-input-component`] = 'single';
        this.loadRefs(element, refs);
        this.refs[`${this.component.key}-renderformbyfile-input-component`]
            .addEventListener('change', (event) => {
            const handleSuccess = (response) => {
                AriFormUtils.removeLoadingFullScreen();
                const dataForm = response.data;
                const form = this.getRoot();
                if (Object.keys(dataForm).length > 0) {
                    for (const key in dataForm) {
                        const value = dataForm[key];
                        if (value === null ||
                            value === undefined ||
                            value === "" ||
                            (Array.isArray(value) && value.length === 0) ||
                            (typeof value === "object" &&
                                !Array.isArray(value) &&
                                Object.keys(value).length === 0)) {
                            continue;
                        }
                        const comp = form.getComponent(key);
                        if (comp) {
                            const type = comp.type;
                            if (type !== "select" && type !== "button") {
                                comp.setValue(dataForm[key]);
                            }
                            else {
                                console.log(comp);
                            }
                        }
                    }
                }
            };
            const handleError = (error) => {
                AriFormUtils.removeLoadingFullScreen();
                console.error('Error uploading file', error);
            };
            const formJson = this.root.schema;
            const file = event.target.files[0];
            if (!file)
                return;
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result.split(',')[1];
                const payload = {
                    fileName: file.name,
                    fileBase64: base64Data,
                    appId: AriForm_1.AriForm.appId,
                    overrideModelId: null,
                    formSpec: formJson ? JSON.stringify(formJson) : ""
                };
                AriFormUtils.loadingFullScreen();
                AriFormUtils.handleCAllAPI(`${AriForm_1.AriForm.baseUrl}/${AriForm_1.AriForm.serviceId}/${AriForm_1.AriForm.uploadFileForAI}`, 'POST', payload, {}, handleSuccess, handleError);
            };
            reader.readAsDataURL(file);
        });
        return super.attach(element);
    }
}
RenderFormbyFileComponent.editForm = renderformbyfile_form_1.default;
RenderFormbyFileComponent.builderInfo = {
    title: 'Render Form by File',
    group: 'basic',
    icon: 'file-earmark-code',
    weight: 3,
    documentation: 'http://help.ari.form/userguide/',
    schema: RenderFormbyFileComponent.schema()
};
exports.default = RenderFormbyFileComponent;
